import React from "react";
import { isInternal } from "../helpers/isInternal";
import AuthPage from "./hoc/AuthPage";

const SignupPage = () => {
  return (
    <AuthPage>
      <div className="flex-grow-1 d-flex align-items-center justify-content-center text-center">
        <h1 className="mb-3">
          Are {isInternal() ? "they" : "you"} a Real Estate Agent?
        </h1>
      </div>
    </AuthPage>
  );
};

export default SignupPage;
